// TODO: Patron Redux en revisión de cargos en proceso
import {
  faCamera,
  faCheckCircle,
  faFileSignature,
  faRecycle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { Button, Container, TabPane, Row, Col } from "reactstrap";
import BasicSpinner from "../../../../toolkit/basicSpinner";
import constants, {
  PARTNER_MEMB_PENDIENTE_FIRMA_CAT_STATUS,
  PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS
} from "../../../../utils/constants";
import {
  createCincelDocumentLink,
  getCincelDocumentFirmantes,
  postRefresh_,
  putCincelFirmas_
} from "../../../actions/expedientes";
import {
  enableForPaymentsStatus,
  getExpedienteFimasCompletas
} from "../../../actions/partners";
import { getPersonByIdRequest } from "../../../actions/persons";
import FormBuilderModal from "../../common/formBuilderModal/formBuilderModal";
import IFrameContainer from "../../common/iframeContainer/iFrameContainer";
import {
  Archivo,
  CreateDocumentLinkRequest,
  RequestArchivo,
  StatusAutorizacion
} from "../../expedientsV2controls/types";
import { catFormConfig } from "../../expedientsV2table/cat.form";
import { Partner } from "../interfaces";
import PhotoDocumentModal from "./photoDocumentModal";
import s from "./styles.scss";
import ModalFrame from "../../../../toolkit/modalFrame";
import OBLoader from "../../../../OnBoardingUI/components/OBLoader/OBLoader.component";
import {
  errorOBNotification,
  successOBNotification
} from "../../../../OnBoardingUI/components/OBNotification/OBNotification.utils";

const CINCEL_MEMBRESIA_CODE_NAME = "CINCEL_MEMBRESIA";
const CINCEL_ALTA_CAT_CODE_NAME = "CINCEL_ALTA_CAT";
const IDENTIFICACION_CODE_NAME = "IDENTIFICACION";
const TITULAR_TYPE = "TITULAR";
const PROPIETARIO_TYPE = "PROPIETARIO";

const URL_SWORD = `${constants.BASE_URL}/api/sworld/`;

interface Props {
  partner: Partner;
  idMembresia: string;
  idMembresiaSocio: string;
  expediente: any;
  loadingData: boolean;
  loadingDataMessage: string;
  invalidateStateValue: (fieldName: string, value: any) => void;
  refreshPartner: () => void;
  getPartnerMembershipExpediente: () => void;
}

class TabDocuments extends React.Component<Props> {
  state = {
    saving: false,
    waiting: false,
    loadingDocument: false,
    loadingDocumentMessage: null,

    iFrameModalIsOpen: false,
    iFrameModalSrc: null,
    iFrameModalArchiveData: null,

    formRegenerateIsOpen: false,
    formRegenerateArchive: null,

    formDocumentPhotoIsOpen: false,
    formDocumentPhotoArchive: null,
    formDocumentPhotoUploadUrl: null,

    showFirmanteSelector: false,
    firmantes: null as any[],
    archivoFirmaOnline: null as Archivo
  };

  isMembershipPendienteTokenizacion = () => {
    return (
      !!this.props.partner &&
      [PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS].includes(
        this.props.partner.estatusMembresia
      )
    );
  };

  isMembershipPendienteFirma = () => {
    return (
      !!this.props.partner &&
      [PARTNER_MEMB_PENDIENTE_FIRMA_CAT_STATUS].includes(
        this.props.partner.estatusMembresia
      )
    );
  };

  findDocumentItemByCodeNameAndType = (codeName, type) => {
    if (!!this.props.expediente && !!this.props.expediente.vigentes) {
      const { vigentes } = this.props.expediente;
      return vigentes.find(di => di.codigo == codeName && di.tipo == type);
    }
    return null;
  };

  renderPartnerMembershipDocumentButton = () => {
    if (!!this.props.expediente) {
      const docItem = this.findDocumentItemByCodeNameAndType(
        CINCEL_MEMBRESIA_CODE_NAME,
        PROPIETARIO_TYPE
      );
      //console.info(docItem);
      if (docItem != null) {
        let buttoLabel = null;
        let buttonIcon = null;
        let buttonClick = null;
        let buttonClassname = "bg-secondary";

        switch (docItem.statusAutorizacion) {
          case StatusAutorizacion.NO_GENERADO:
            buttoLabel = "Generar carátula de membresía";
            buttonIcon = faFileSignature;
            buttonClick = () => {
              this.regenerar(docItem);
            };
            break;
          case StatusAutorizacion.NO_AUTORIZADO:
            buttoLabel = "Firmar carátula de membresía";
            buttonIcon = faFileSignature;
            buttonClick = () => {
              this.firmarOnline(docItem);
            };
            break;
          case StatusAutorizacion.AUTORIZADO:
            buttoLabel = "Carátula de membresía completada";
            buttonIcon = faCheckCircle;
            buttonClick = () => {};
            buttonClassname = "bg-success";
            break;
        }

        return (
          <Button
            className={`${buttonClassname} mr-4`}
            size="md"
            disabled={!!this.state.waiting}
            block
            onClick={buttonClick}
          >
            <FontAwesomeIcon icon={buttonIcon} />
            <span className="ml-5">{buttoLabel}</span>
          </Button>
        );
      }
    }

    return <></>;
  };

  renderCatDocumentButton = () => {
    if (!!this.props.expediente) {
      const docItem = this.findDocumentItemByCodeNameAndType(
        CINCEL_ALTA_CAT_CODE_NAME,
        PROPIETARIO_TYPE
      );
      //console.info(docItem);
      if (docItem != null) {
        let buttoLabel = null;
        let buttonIcon = null;
        let buttonClick = null;
        let buttonClassname = "bg-secondary";

        switch (docItem.statusAutorizacion) {
          case StatusAutorizacion.NO_GENERADO:
            buttoLabel = "Generar cargo recurrente";
            buttonIcon = faFileSignature;
            buttonClick = () => {
              this.setState({
                formRegenerateIsOpen: true,
                formRegenerateArchive: docItem
              });
            };
            break;
          case StatusAutorizacion.NO_AUTORIZADO:
            buttoLabel = "Firmar cargo recurrente";
            buttonIcon = faFileSignature;
            buttonClick = () => {
              this.firmarOnline(docItem);
            };
            break;
          case StatusAutorizacion.AUTORIZADO:
            buttoLabel = "Cargo recurrente completado";
            buttonIcon = faCheckCircle;
            buttonClick = () => {};
            buttonClassname = "bg-success";
            break;
        }

        return (
          <Button
            className={`${buttonClassname} mr-4`}
            size="md"
            disabled={!!this.state.waiting}
            block
            onClick={buttonClick}
          >
            <FontAwesomeIcon icon={buttonIcon} />
            <span className="ml-5">{buttoLabel}</span>
          </Button>
        );
      }
    }

    return <></>;
  };

  renderIneDocumentButton = () => {
    if (!!this.props.expediente) {
      const docItem = this.findDocumentItemByCodeNameAndType(
        IDENTIFICACION_CODE_NAME,
        TITULAR_TYPE
      );
      //console.info(docItem);
      if (docItem != null) {
        const { idExpediente, idItem } = docItem;
        const urlUpload = `${URL_SWORD}expedients/${idExpediente}/upload/${idItem}`;

        let buttoLabel = null;
        let buttonIcon = null;
        let buttonClick = null;
        let buttonClassname = "bg-secondary";

        if (!docItem.completo) {
          buttoLabel = "Identificación INE";
          buttonIcon = faCamera;
          buttonClick = () => {
            this.setState({
              formDocumentPhotoIsOpen: true,
              formDocumentPhotoArchive: docItem,
              formDocumentPhotoUploadUrl: urlUpload
            });
          };
        } else {
          buttoLabel = "Identificación INE completada";
          buttonIcon = faCheckCircle;
          buttonClick = () => {};
          buttonClassname = "bg-success";
        }

        return (
          <Button
            className={`${buttonClassname} mr-4`}
            size="md"
            disabled={!!this.state.waiting}
            block
            onClick={buttonClick}
          >
            <FontAwesomeIcon icon={buttonIcon} />
            <span className="ml-5">{buttoLabel}</span>
          </Button>
        );
      }
    }

    return <></>;
  };

  regenerar = async (archivo: Archivo, values?: any) => {
    const requestArchivo: RequestArchivo = {
      codigo: archivo.codigo,
      idMembresiaSocio: this.props.idMembresiaSocio,
      idPersonaExpediente: null,
      idMembresiaSocioPersona: archivo.idMembresiaSocioPersona,
      idPersonaDocumento: archivo.idPersona,
      idMedioPago: archivo.idMedioPago,
      idCotizacionItem: archivo.idCotizacionItem,
      idPersonaEvaluacion: archivo.idPersonaEvaluacion,
      values
    };

    const result = await postRefresh_(requestArchivo);

    if (result != null && result.status == 200) {
      this.setState({
        formRegenerateIsOpen: false,
        formRegenerateArchive: null
      });

      successOBNotification("El documento se generó correctamente");
      this.props.invalidateStateValue("expediente", null);
      this.props.getPartnerMembershipExpediente();
    }

    return result;
  };

  update = async () => {
    this.props.invalidateStateValue("expediente", null);
    this.props.getPartnerMembershipExpediente();

    const { data } = await getExpedienteFimasCompletas(
      this.props.idMembresiaSocio
    );

    if (!!data && !!data.body) {
      await enableForPaymentsStatus(this.props.idMembresiaSocio);

      if (!!this.props.refreshPartner) {
        this.props.refreshPartner();
      }
    }
  };

  cincelFirma = async (archivo: Archivo) => {
    if (archivo.statusAutorizacion == StatusAutorizacion.NO_GENERADO) {
      errorOBNotification(
        "Debe generar el documento antes de verificar las firmas"
      );

      return {
        fulfilled: false
      };
    }

    const result = await putCincelFirmas_(archivo.idExpediente, archivo.idItem);

    console.info("PutCincelFirmas Result: ", result);

    if (result != null && result.status == 200) {
      successOBNotification("El documento firmado se obtuvo correctamente");

      this.props.invalidateStateValue("expediente", null);
      this.props.getPartnerMembershipExpediente();
    }

    const { data } = await getExpedienteFimasCompletas(
      this.props.idMembresiaSocio
    );

    if (!!data && !!data.body) {
      await enableForPaymentsStatus(this.props.idMembresiaSocio);

      if (!!this.props.refreshPartner) {
        this.props.refreshPartner();
      }
    }
  };

  firmarOnline = async (archivo: Archivo) => {
    if (archivo.completo) {
      errorOBNotification("El documento ya se encuentra firmado.");
      return;
    }

    try {
      const { data } = await getCincelDocumentFirmantes(
        archivo.idExpediente,
        archivo.idItem
      );

      const firmantes = ((data || {}).firmantes || []).reverse();

      if (!firmantes || firmantes.length <= 0) {
        errorOBNotification("No se encontraron firmantes para el documento.");
      } else if (firmantes.length == 1) {
        // Si solo hay un firmante, se firma directamente
        await this.firmarOnlineFirmante(firmantes[0], archivo);
      } else {
        // Si hay más de un firmante, se muestra el selector
        this.setState({
          showFirmanteSelector: true,
          firmantes,
          archivoFirmaOnline: archivo
        });
      }
    } catch (error) {
      errorOBNotification(
        error && error.response && error.response.data
          ? error.response.data.message || "Error al obtener firmantes"
          : "Error al obtener firmantes"
      );
    }
  };

  firmarOnlineFirmante = async (firmante: any, archivo: Archivo) => {
    try {
      //Se obtienen la info de los firmantes del documento
      console.info("Archivo: ", archivo);

      const archivoPersonaId = archivo.idPersona || archivo.idOwner || null;

      const { data: personaResult } = await getPersonByIdRequest(
        archivoPersonaId
      );
      if (!personaResult) {
        errorOBNotification("La persona asociada al documento no existe");
        return;
      }

      if ((personaResult.curp || "").length <= 0) {
        errorOBNotification(
          "La persona no cuenta con un curp válido y registrado"
        );
        return;
      }

      const createCincelDocumentLinkRequest: CreateDocumentLinkRequest = {
        idExpediente: archivo.idExpediente,
        idItem: archivo.idItem,
        idPersona: firmante.idPersona,
        firmanteUuid: firmante.firmanteUuid,
        documentoUuid: firmante.documentoUuid,
        curp: firmante.curp || personaResult.curp || null,
        email: firmante.email,
        nombre: firmante.nombre
      };

      console.info(
        "CreateDocumentLinkRequest: ",
        createCincelDocumentLinkRequest
      );

      const { data: createLinkResult } = await createCincelDocumentLink(
        createCincelDocumentLinkRequest
      );
      console.info("Create link result: ", createLinkResult);
      if (!!createLinkResult && !!createLinkResult.url) {
        //window.open(createLinkResult.url, "_blank");
        this.setState({
          iFrameModalIsOpen: true,
          iFrameModalSrc: createLinkResult.url,
          iFrameModalArchiveData: archivo
        });
        return;
      }
    } catch (error) {
      errorOBNotification("Error al abrir documento para firma.");
      this.setState({
        iFrameModalIsOpen: false,
        iFrameModalSrc: null,
        iFrameModalArchiveData: null
      });
    }
  };

  render() {
    //console.info("Expediente desde tabdocuments...", this.props.expediente);

    if (!!this.props.loadingData) {
      return (
        <div className="text-center">
          <OBLoader
            activity={this.props.loadingDataMessage || "Consultando documentos"}
            loading={this.props.loadingData}
          />
        </div>
      );
    }

    if (!!this.state.loadingDocument) {
      return (
        <div className="text-center">
          <OBLoader
            activity={this.state.loadingDocumentMessage || "Cargando documento"}
            loading={this.state.loadingDocument}
          />
        </div>
      );
    }

    return (
      <TabPane className="my-2" tabId="2">
        <Container className="p-0 m-0">
          <div style={{ marginLeft: "24px" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                marginBottom: "4px"
              }}
            >
              Nombre del cliente:
            </div>
            <div
              style={{
                fontSize: "12px",
                marginBottom: "10px"
              }}
            >
              {this.props.partner.nombrePersona}
            </div>
          </div>
          <hr />
          {this.isMembershipPendienteTokenizacion() && (
            <div
              className={`${s.infoCard} ${s.gray}`}
              style={{ margin: "0 24px 10px 24px" }}
            >
              Antes de completar tu expediente, tienes que registrar un medio de
              pago recurrente.
            </div>
          )}
          {!this.isMembershipPendienteTokenizacion() &&
            !this.isMembershipPendienteFirma() && (
              <div
                className={`${s.infoCard} ${s.gray}`}
                style={{ margin: "0 24px 10px 24px" }}
              >
                Tu expediente está completo, por favor, continúa en la siguiente
                pestaña.
              </div>
            )}

          {/* Modal de formulario de regeneración */}
          <FormBuilderModal
            isOpen={this.state.formRegenerateIsOpen}
            title="Información adicional"
            message={"Complete la información del documento"}
            ok={async values => {
              await this.regenerar(
                { ...this.state.formRegenerateArchive },
                values
              );
            }}
            cancel={() =>
              this.setState({
                formRegenerateIsOpen: false,
                formRegenerateArchive: null
              })
            }
            formConfig={catFormConfig}
            values={null}
            size={"sm"}
            danger={null}
          />

          {/* Modal de confirmación */}
          <PhotoDocumentModal
            title={"Foto de identificación oficial"}
            isOpen={this.state.formDocumentPhotoIsOpen}
            cancel={() => {
              this.setState({
                formDocumentPhotoIsOpen: false,
                formDocumentPhotoArchive: null,
                formDocumentPhotoUrlUpload: null
              });
            }}
            success={() => {
              this.setState({
                formDocumentPhotoIsOpen: false,
                formDocumentPhotoArchive: null,
                formDocumentPhotoUrlUpload: null
              });

              this.update();
            }}
            urlUpload={this.state.formDocumentPhotoUploadUrl}
          />

          {this.renderFirmanteSelector()}

          {this.isMembershipPendienteFirma() && !this.state.iFrameModalIsOpen && (
            <>
              <div className="m-4">
                {this.renderPartnerMembershipDocumentButton()}
              </div>

              <div className="m-4">{this.renderCatDocumentButton()}</div>

              <div className="m-4">{this.renderIneDocumentButton()}</div>
            </>
          )}

          {this.isMembershipPendienteFirma() && this.state.iFrameModalIsOpen && (
            <IFrameContainer
              title={"Firma de documento"}
              okTitle={"Procesar firmas"}
              waitingMessage={"Procesando firmas"}
              ok={async () => {
                await this.setState({
                  loadingDocument: true,
                  loadingDocumentMessage: "Procesando firmas"
                });

                const { iFrameModalArchiveData } = this.state;

                this.cincelFirma({ ...iFrameModalArchiveData });

                this.setState({
                  loadingDocument: false,
                  loadingDocumentMessage: null,
                  iFrameModalSrc: null,
                  iFrameModalIsOpen: false,
                  iFrameModalArchiveData: null
                });
              }}
              cancel={() => {
                this.setState({
                  loadingDocument: false,
                  loadingDocumentMessage: null,
                  iFrameModalSrc: null,
                  iFrameModalIsOpen: false,
                  iFrameModalArchiveData: null
                });
              }}
              src={this.state.iFrameModalSrc}
            />
          )}
        </Container>
      </TabPane>
    );
  }

  renderFirmanteSelector = () => {
    if (!this.state.firmantes) {
      return null;
    }

    const archivo = this.state.archivoFirmaOnline;

    return (
      <ModalFrame
        title={"Seleccionar firmante"}
        isOpen={this.state.showFirmanteSelector}
        toggle={() => this.setState({ showFirmanteSelector: false })}
        size="md"
      >
        <Container style={{ width: "90%" }} className="center-block p-0 mb-3">
          <Row>
            <div
              style={{
                backgroundColor: "#eee",
                fontSize: "11px",
                fontWeight: "bold",
                padding: "4px",
                width: "100%",
                textAlign: "center"
              }}
            >
              Recuerde que las firmas siguen cierto orden.
            </div>
          </Row>
          {this.state.firmantes.map(firmante => (
            <Row key={firmante.firmanteUuid} className="mt-2 mb-3">
              <Col xs="12" md="12">
                <div
                  style={{
                    padding: "4px",
                    borderRadius: "5px",
                    backgroundColor: "#fff2cc"
                  }}
                >
                  Firmante: {firmante.nombre}
                  <br />
                  <span style={{ fontSize: "12px" }}>{firmante.email}</span>
                </div>
              </Col>
              <Col xs="12" md="12">
                <Button
                  className={`${s.secundaryButton} mt-3`}
                  onClick={() => {
                    this.firmarOnlineFirmante(firmante, archivo);
                    this.setState({ showFirmanteSelector: false });
                  }}
                  block
                  disabled={this.state.waiting || archivo.completo}
                >
                  Firmar
                </Button>
              </Col>
              <Col xs="12" md="12">
                <hr />
              </Col>
            </Row>
          ))}

          <Row className="mt-2">
            <Col xs="12" md="12">
              <Button
                className={`${s.secundaryButton} mt-3`}
                onClick={() => {
                  this.setState({ showFirmanteSelector: false });
                }}
                block
                disabled={this.state.waiting}
              >
                Cancelar
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalFrame>
    );
  };
}

export default withStyles(s)(TabDocuments);
